import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ITableHeaderOption } from '../../../interfaces/table/table-header-option';
import { ITableOrder } from '../../../interfaces/table/table-order';
import { RowThickness } from '../table';

@Component({
  selector: 'app-header-table',
  templateUrl: './header-table.component.html',
  styleUrls: ['./header-table.component.scss'],
})
export class HeaderTableComponent implements OnInit {
  public headerOptions: ITableHeaderOption[];
  public orderColumn: ITableOrder;
  public rowThicknessEnum = RowThickness;

  @Input()
  public set headers(headers: ITableHeaderOption[]) {
    if (headers) {
      this.headerOptions = headers;
      this.ngOnInit();
    }
  }

  @Input() public thickness: RowThickness;

  @Output()
  public sortCall: EventEmitter<ITableOrder>;

  constructor() {
    this.sortCall = new EventEmitter();
    this.headerOptions = [];
    this.orderColumn = {
      key: null,
      order: null,
    };
  }

  /**
   * Init component
   */
  public ngOnInit(): void {}

  /**
   * Function to call the event emitter to sort by key in DataTableComponent
   */
  public sortByKey(key: string, sortBy: string): void {
    this.toggleOrder(key, sortBy);
    this.sortCall.emit(this.orderColumn);
  }

  /**
   * Function to toggle order in "asc" or "desc"
   */
  private toggleOrder(key: string, sortBy: string): void {
    const sortKey = sortBy || key;

    if (this.orderColumn.key !== sortKey) {
      this.orderColumn.key = sortKey;
      this.orderColumn.order = 'asc';
    } else if (this.orderColumn.order === 'asc') {
      this.orderColumn.order = 'desc';
    } else if (this.orderColumn.order === 'desc') {
      this.orderColumn.order = null;
    } else if (this.orderColumn.order === null) {
      this.orderColumn.order = 'asc';
    }
  }

  /**
   * Function to show or hide the sort images
   */
  public showSortImage(key: string, order: string): any {
    const orderKey = this.orderColumn.key;
    const orderSort = this.orderColumn.order;

    if (orderKey === key) {
      if (orderSort === null) {
        return { opacity: '1', 'margin-top': order === 'asc' ? '-14px' : '8px' };
      }
      if ((order === 'asc' && orderSort === 'asc') || (order === 'desc' && orderSort === 'desc')) {
        return { opacity: '1', 'margin-top': '-2px' };
      }
      return { opacity: '0', 'margin-top': '0' };
    }
    return {
      opacity: '1',
      'margin-top': order === 'asc' ? '-14px' : '8px',
    };
  }
}
